import React from 'react';
import '../Styles/Heading.css'

const Heading = ({text}) => {
  return (
    <div className='headsection'>
        <div></div>
        <p>{text}</p>
        <div></div>
    </div>
  )
}

export default Heading